export const FREE_ACCESS_EMAILS = ["jpattison54319@gmail.com"];

export function hasFreeAccess(email: string | null | undefined): boolean {
  return FREE_ACCESS_EMAILS.includes((email ?? "").trim().toLowerCase());
}
